export default {
  filters: {
    monefy(val) {
      return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(
        val
      );
    },
  },
};
